import { Button } from '@mantine/core';
import { IconFileTypeDocx, IconFileTypePdf } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { getMinStdDownloadableReportUrl } from '@/module/MinimalStandard/model/MinStdApi';

import { JobTitle } from '@feature/utils';

interface MinStdDownloadableReportButtonProps {
  authorId: number;
  fileType: 'pdf' | 'docx';

  jobTitle: JobTitle | null;
  startYear: number;
  endYear: number;
}

export function MinStdDownloadableReportButton(props: MinStdDownloadableReportButtonProps) {
  const { authorId, fileType, jobTitle, startYear, endYear } = props;
  const { t } = useTranslation();

  const onClick = () => {
    window.open(getMinStdDownloadableReportUrl(authorId, jobTitle, startYear, endYear, fileType));
  };

  return (
    <Button
      size="xs"
      leftSection={fileType === 'pdf' ? <IconFileTypePdf size="16px" /> : <IconFileTypeDocx size="16px" />}
      onClick={onClick}
    >
      {fileType === 'pdf' ? t('minStd.downloadReportPdf') : t('minStd.downloadReportWord')}
    </Button>
  );
}
